export { SloganSecondary } from './SloganSecondary';
